import router from "@/router";
import { encrypt, decrypt } from "./EncryptionService";
import JwtService from "./JwtService";
const storageKey = "Claims"

export const hasPermission = (claim: string): boolean => {
  if (hasAdminPermission()) {
    return true;
  }

  let _hasPermission = true;

  const claims = getClaims().map(function (_claim) {
    return _claim.toLowerCase()
  });

  claim = claim.toLowerCase()

  if (claim.includes("&")) {
    const requiredClaims = claim.split("&")
    for (let i = 0; i < requiredClaims.length; i++) {
      if (!claims.includes(requiredClaims[i])) {
        _hasPermission = false;
      }
      if (!_hasPermission) {
        break;
      }
    }
  }
  else if (claim.includes("|")) {
    _hasPermission = false;
    const requiredClaims = claim.split("|")

    for (let i = 0; i < requiredClaims.length; i++) {
      if (claims.includes(requiredClaims[i])) {
        _hasPermission = true;
      }
      if (_hasPermission) {
        break;
      }
    }
  }
  else {
    _hasPermission = claims.includes(claim)
  }

  return _hasPermission;
};

export const hasAdminPermission = (): boolean => {
  const user = JwtService.getUser();
  if (user) {
    if (user.isGlobalAdmin) {
      return true
    }
  }
  return false
}

export const checkPermissionAndRedirectIfUnauthorized = (claim: string, isAdminAction = false) => {
  let _hasPermission = false;
  if (isAdminAction) {
    _hasPermission = hasAdminPermission()
  }
  else {
    _hasPermission = hasPermission(claim)
  }

  if (!_hasPermission) {
    router.push("401")
  }
}

export const saveClaims = (claims: Array<any>): void => {
  const claimsJson = JSON.stringify(claims)
  const encryptedClaims = encrypt(claimsJson)

  localStorage.setItem(storageKey, encryptedClaims);
}

export const getClaims = (): Array<string> => {
  const encryptedClaims = localStorage.getItem(storageKey);
  if (encryptedClaims) {
    const claimsJson = decrypt(encryptedClaims)
    if (claimsJson) {
      return JSON.parse(claimsJson)
    }
  }
  return []
}

export default { hasPermission, saveClaims, getClaims, hasAdminPermission, checkPermissionAndRedirectIfUnauthorized };
